import React from 'react';

export type InfoBlockContextValue = {
  loading: boolean;
};

export const DEFAULT_INFO_BLOCK_CONTEXT: InfoBlockContextValue = {
  loading: false,
};

export const InfoBlockContext = React.createContext<InfoBlockContextValue>(
  DEFAULT_INFO_BLOCK_CONTEXT,
);
